import { motion } from 'framer-motion'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import styles from './SDKs.module.css'

const sdks = [
  {
    name: 'Python SDK',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M14.25.18l.9.2.73.26.59.3.45.32.34.34.25.34.16.33.1.3.04.26.02.2-.01.13V8.5l-.05.63-.13.55-.21.46-.26.38-.3.31-.33.25-.35.19-.35.14-.33.1-.3.07-.26.04-.21.02H8.77l-.69.05-.59.14-.5.22-.41.27-.33.32-.27.35-.2.36-.15.37-.1.35-.07.32-.04.27-.02.21v3.06H3.17l-.21-.03-.28-.07-.32-.12-.35-.18-.36-.26-.36-.36-.35-.46-.32-.59-.28-.73-.21-.88-.14-1.05-.05-1.23.06-1.22.16-1.04.24-.87.32-.71.36-.57.4-.44.42-.33.42-.24.4-.16.36-.1.32-.05.24-.01h.16l.06.01h8.16v-.83H6.18l-.01-2.75-.02-.37.05-.34.11-.31.17-.28.25-.26.31-.23.38-.2.44-.18.51-.15.58-.12.64-.1.71-.06.77-.04.84-.02 1.27.05zm-6.3 1.98l-.23.33-.08.41.08.41.23.34.33.22.41.09.41-.09.33-.22.23-.34.08-.41-.08-.41-.23-.33-.33-.22-.41-.09-.41.09zm13.09 3.95l.28.06.32.12.35.18.36.27.36.35.35.47.32.59.28.73.21.88.14 1.04.05 1.23-.06 1.23-.16 1.04-.24.86-.32.71-.36.57-.4.45-.42.33-.42.24-.4.16-.36.09-.32.05-.24.02-.16-.01h-8.22v.82h5.84l.01 2.76.02.36-.05.34-.11.31-.17.29-.25.25-.31.24-.38.2-.44.17-.51.15-.58.13-.64.09-.71.07-.77.04-.84.01-1.27-.04-1.07-.14-.9-.2-.73-.25-.59-.3-.45-.33-.34-.34-.25-.34-.16-.33-.1-.3-.04-.25-.02-.2.01-.13v-5.34l.05-.64.13-.54.21-.46.26-.38.3-.32.33-.24.35-.2.35-.14.33-.1.3-.06.26-.04.21-.02.13-.01h5.84l.69-.05.59-.14.5-.21.41-.28.33-.32.27-.35.2-.36.15-.36.1-.35.07-.32.04-.28.02-.21V6.07h2.09l.14.01zm-6.47 14.25l-.23.33-.08.41.08.41.23.33.33.23.41.08.41-.08.33-.23.23-.33.08-.41-.08-.41-.23-.33-.33-.23-.41-.08-.41.08z"/>
      </svg>
    ),
    install: '# From cloned repo: cd src/client/luminox-py && pip install -e .',
    code: `from luminox import LuminoxClient

client = LuminoxClient(
    base_url="http://localhost:8029/api/v1"
)
session = client.sessions.create()

# Store any LLM format
client.sessions.store_message(
    session_id=session.id,
    blob=message,
    format="openai"  # or "anthropic"
)`,
    docsLink: 'https://github.com/luminox-mem/luminox/tree/main/src/client/luminox-py',
  },
  {
    name: 'TypeScript SDK',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.395c.272.12.576.237.912.352.436.153.855.323 1.256.512.4.19.76.418 1.08.685.319.267.574.584.765.951.19.368.287.805.287 1.311 0 .612-.11 1.135-.328 1.568-.219.433-.527.79-.923 1.071a4.044 4.044 0 0 1-1.4.63c-.537.14-1.121.21-1.751.21a9.485 9.485 0 0 1-1.82-.162 6.488 6.488 0 0 1-1.451-.464v-2.517c.246.175.516.335.809.479.293.143.598.262.914.356.316.095.641.168.972.22.331.052.659.078.985.078.301 0 .574-.024.819-.071a1.905 1.905 0 0 0 .624-.222c.17-.096.3-.218.393-.368a.965.965 0 0 0 .14-.516c0-.214-.064-.407-.191-.578a1.974 1.974 0 0 0-.544-.463 5.437 5.437 0 0 0-.847-.39 15.106 15.106 0 0 0-1.111-.423 9.89 9.89 0 0 1-1.203-.495 4.185 4.185 0 0 1-1.003-.686 3.079 3.079 0 0 1-.69-.95c-.168-.373-.253-.807-.253-1.299 0-.578.103-1.078.31-1.499.206-.421.504-.77.894-1.048a4.14 4.14 0 0 1 1.379-.647 6.445 6.445 0 0 1 1.75-.231zM7.586 14.065l1.965-5.125h2.35l-3.15 7.35H6.95l-3.15-7.35h2.4l1.986 5.125z"/>
      </svg>
    ),
    install: 'npm install luminox-sdk',
    code: `import { LuminoxClient } from 'luminox-sdk';

const client = new LuminoxClient({
  baseUrl: 'http://localhost:8029/api/v1'
});

const session = await client.sessions.create();
await client.sessions.storeMessage({
  sessionId: session.id,
  blob: message,
  format: 'openai'
});`,
    docsLink: 'https://github.com/luminox-mem/luminox/tree/main/src/client/luminox-ts',
  },
  {
    name: 'CLI Tool',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M4 4h16v16H4V4zm0 0v16h16V4H4zm2 2h12v12H6V6zm1 1v10h10V7H7zm1 1h8v8H8V8z"/>
      </svg>
    ),
    install: 'git clone https://github.com/luminox-mem/luminox.git',
    code: `# Start self-hosted backend
cd luminox
docker compose up -d

# Access the dashboard
# http://localhost:3000

# API endpoint
# http://localhost:8029/api/v1`,
    docsLink: 'https://github.com/luminox-mem/luminox/tree/main/src/client/luminox-cli',
  },
]

export default function SDKs() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>()

  return (
    <section id="sdks" className={styles.sdks} ref={ref}>
      <motion.div
        className="section-header"
        initial={{ opacity: 0, y: 20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <span className="section-tag">Developer Experience</span>
        <h2 className="section-title">First-Class SDK Support</h2>
      </motion.div>

      <div className={styles.grid}>
        {sdks.map((sdk, index) => (
          <motion.div
            key={sdk.name}
            className={styles.card}
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            whileHover={{
              borderColor: 'rgba(255, 215, 0, 0.3)',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
            }}
          >
            <div className={styles.header}>
              <div className={styles.icon}>{sdk.icon}</div>
              <h3>{sdk.name}</h3>
            </div>
            <div className={styles.install}>
              <code>{sdk.install}</code>
            </div>
            <pre className={styles.code}>
              <code>{sdk.code}</code>
            </pre>
            <motion.a
              href={sdk.docsLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
              whileHover={{ gap: '12px' }}
            >
              View Docs <span>→</span>
            </motion.a>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
